(function () {
  function sync(btn) {
    var off = btn.classList.contains('is-unavailable');
    btn.setAttribute('aria-disabled', off ? 'true' : 'false');
    if (off && !/indisponible/i.test(btn.getAttribute('aria-label') || '')) {
      btn.setAttribute('aria-label', (btn.getAttribute('aria-label') || btn.title || '') + ' — indisponible');
    }
  }
  function bind(root) {
    (root || document).querySelectorAll('[data-soniel-picker]').forEach(function (picker) {
      if (picker.dataset.a11y === '1') return;
      picker.dataset.a11y = '1';
      picker.querySelectorAll('[data-option-btn]').forEach(sync);
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.target && m.target.hasAttribute && m.target.hasAttribute('data-option-btn')) sync(m.target);
        });
      }).observe(picker, { subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
  else bind(document);
})();
